import { IProjectType } from "../../../@types/project/project.type"


export const includeCustomFieldsfromApi = (project:IProjectType) => {

  const customFieldsObject = Array.isArray(project.customFields)
  ? Object.fromEntries(
      project.customFields.map(({ key, value }) => [key, value])
    )
  : {};

  return {
    ...project,
    customFieldsObject,
    customFields: undefined,
  }
}


export const includeCustomFieldstoApi = (project:IProjectType, formDataCustomFields: Record<string, any>) => {

  const customFields = Object.entries(formDataCustomFields).map(([key, value]) => ({ key, value: value !== null ? String(value) : value })); 

  return {
    ...project,
    customFields,
  }
}
